/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MembershipRoleUpdate = {
    role: MembershipRoleUpdate.role;
};

export namespace MembershipRoleUpdate {

    export enum role {
        OWNER = 'owner',
        ADMIN = 'admin',
        EDITOR = 'editor',
    }


}

